/**
 * Конвертация между значением <input type="datetime-local"> (локальное время
 * без зоны) и ISO-UTC, который уходит на бэкенд.
 */

export function toDateTimeLocal(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
}

/** Пустая или невалидная строка → null, чтобы вызывающий не слал мусор. */
export function fromDateTimeLocal(value: string): string | null {
  if (!value) return null;
  const ms = new Date(value).getTime();
  return Number.isFinite(ms) ? new Date(ms).toISOString() : null;
}
